import { useState } from 'react';

export default function Differentials() {
  const [activeCard, setActiveCard] = useState(0);

  const differentials = [
    {
      title: 'Fachada Contemporânea',
      description: 'Design moderno e sofisticado que se destaca na paisagem urbana do Centro de Curitiba.',
      icon: 'ri-building-4-line',
      color: 'bg-blue-100 text-blue-600',
    },
    {
      title: 'Estacionamento Rotativo no Subsolo',
      description: 'Sistema inteligente de estacionamento rotativo para maior comodidade e segurança.',
      icon: 'ri-parking-box-line',
      color: 'bg-green-100 text-green-600',
    },
    {
      title: 'Mais de 25 Áreas de Lazer',
      description: 'Infraestrutura completa com diversas opções de lazer e convivência para todos os perfis.',
      icon: 'ri-community-line',
      color: 'bg-orange-100 text-orange-600',
    },
    {
      title: 'Aquecimento Central de Água',
      description: 'Sistema hoteleiro de aquecimento central para máximo conforto e economia.',
      icon: 'ri-temp-hot-line',
      color: 'bg-red-100 text-red-600',
    },
    {
      title: 'Airbnb Friendly',
      description: 'Convenção de condomínio que permite locação por temporada, ideal para investidores.',
      icon: 'ri-home-heart-line',
      color: 'bg-purple-100 text-purple-600',
    },
    {
      title: 'Elevador Panorâmico',
      description: 'Vista privilegiada da cidade durante o trajeto, agregando valor e sofisticação.',
      icon: 'ri-arrow-up-down-line',
      color: 'bg-teal-100 text-teal-600',
    },
  ];

  return (
    <section id="diferenciais" className="bg-white py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black mb-4">
            Diferenciais do ATMOS
          </h2>
          <p className="text-gray-600 text-lg">
            Características exclusivas que fazem do ATMOS um empreendimento único
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {differentials.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 cursor-pointer"
              onMouseEnter={() => setActiveCard(index)}
            >
              {/* Icon */}
              <div className={`w-16 h-16 ${item.color} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${item.icon} text-3xl`}></i>
              </div>

              {/* Content */}
              <h3 className="font-sans font-bold text-xl text-black mb-3">
                {item.title}
              </h3>
              <p className="text-gray-700 text-base leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a
            href="https://wa.me/5541988674555?text=Olá! Quero conhecer todos os diferenciais do ATMOS."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-primary text-white px-8 py-4 rounded-full font-semibold hover:bg-primary/90 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>Falar com Consultor</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
